import { CalendarNativeDateFormatter } from './calendarNativeDateFormatter.provider';

export class CalendarDateFormatter extends CalendarNativeDateFormatter {}


// WEBPACK FOOTER //
// ./~/tslint-loader?emitErrors=true&failOnHint=true!./src/providers/calendarDateFormatter.provider.ts